export const LEGAL_ROUTE_PATHS = {
  privacyPolicy: "/privacy-policy",
  cookiePolicy: "/cookie-policy",
  legalNotice: "/legal-notice",
} as const;

export const LEGAL_FOOTER_LINKS = [
  { to: LEGAL_ROUTE_PATHS.privacyPolicy, labelKey: "routes.privacyPolicy" },
  { to: LEGAL_ROUTE_PATHS.cookiePolicy, labelKey: "routes.cookiePolicy" },
  { to: LEGAL_ROUTE_PATHS.legalNotice, labelKey: "routes.legalNotice" },
] as const;

export const COOKIE_CATEGORY_KEYS = ["necessary", "analytics", "marketing"] as const;

export type CookieCategoryKey = (typeof COOKIE_CATEGORY_KEYS)[number];
